import styled from 'styled-components';

export const StyledFloorPlan = styled.div`
  position: absolute;
  right: 20px;
  top: 20px;
  color: var(--color-text-main);
  height: 40px;
  background-color: #dadada;
  box-shadow: 0px 1px 3px 0px #0f22431f;
  border-radius: 5px;
  padding: 10px;
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;

  .title {
    font-size: 14px;
    font-weight: 500;
    color: #878787;
  }

  .tab-btn {
    width: 85px;
    height: 34px;
    font-size: 14px;
    font-weight: 500;
    color: #878787;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .tab-btn.active {
    color: #055cb4;
    background-color: #ffffff;
    border-radius: 4px;
    border: 0.5px solid #cfcfcf;
  }
`;
